<div class="rule-association-content">
  <app-rules-association-content-area *ngIf="rulesAssociationDetails"
                                      [rulesAssociationDetails]="rulesAssociationDetails"></app-rules-association-content-area>
  <app-rules-association-list class="rules-association-list" *ngIf="rulesAssociationDetails"
                              [rulesAssociationDetails]="rulesAssociationDetails"></app-rules-association-list>
  <div class="rule-association-footer">
    <app-rules-association-footer *ngIf="rulesAssociationCommonService.ruleAssociationStatuses"></app-rules-association-footer>
  </div>
</div>
